(function () {
    $(document).ready(function () {

        /*-----*/
        /*fix filter-tab and sorting on scroll in mobile -- start*/

        /*
        * когда доскролим до сортировки и фильтров в мобилке - фиксировать их
        * */

        if ($('.catalog-control-wrap').length) {
            var $senat_catalog_section__with_filter = $('.senat-catalog-section.with-filter');
            // var $sortingMobTab = $('.senat-sort-new');
            // var $filterTabMob = $('.filter-tab.filter-mobile-control');
            var $catalogControlWrap = $('.catalog-control-wrap');
            var $s_lastScrollTop = 0; // Переменная для хранения предыдущей позиции скролла
            var $body = $("body");

            function fixedSortingOnScroll_mobile() {
                var $scrollTop = $(window).scrollTop();

                if ($scrollTop < $s_lastScrollTop && $scrollTop > $senat_catalog_section__with_filter.offset().top) {
                    $body.delay(800).addClass("fixed-sorting");
                    $catalogControlWrap.delay(800).addClass("fixed_scrollUp");
                    // $sortingMobTab.delay(800).addClass("fixed_scrollUp");
                    // $filterTabMob.addClass("fixed_scrollUp");
                } else if ($scrollTop > $s_lastScrollTop && $scrollTop > $senat_catalog_section__with_filter.offset().top) {
                    $catalogControlWrap.delay(800).removeClass("fixed_scrollUp").addClass("fixed_scrollDown");
                    // $sortingMobTab.delay(800).removeClass("fixed_scrollUp").addClass("fixed_scrollDown");
                    // $filterTabMob.removeClass("fixed_scrollUp").addClass("fixed_scrollDown");
                } else {
                    $catalogControlWrap.delay(800).removeClass("fixed_scrollDown").removeClass("fixed_scrollUp");
                    // $sortingMobTab.delay(800).removeClass("fixed_scrollDown").removeClass("fixed_scrollUp");
                    // $filterTabMob.removeClass("fixed_scrollDown").removeClass("fixed_scrollUp");
                    $body.delay(800).removeClass("fixed-sorting");
                }

                $s_lastScrollTop = $scrollTop;

            }

            // Вызов функций при скролле страницы
            if ($(window).width() < 768) {
                $(window).scroll(function () {
                    fixedSortingOnScroll_mobile();
                });
            }
        }

        /*fix filter-tab and sorting on scroll in mobile -- end*/
        /*----*/
    });
})();
